import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "container" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", { class: "d-flex py-5" }, [
  /*#__PURE__*/_createElementVNode("h2", null, "Pemangkuan/Kenaikan Pangkat")
], -1)
const _hoisted_3 = { class: "row g-5" }
const _hoisted_4 = { class: "card h-100" }
const _hoisted_5 = { class: "card-body p-5" }
const _hoisted_6 = { class: "d-flex align-items-center mb-2" }
const _hoisted_7 = {
  class: /*#__PURE__*/_normalizeClass([
                  'badge',
                  'badge-outline',
                  'pertukaran',
                  'mb-2',
                  'me-2',
                ])
}
const _hoisted_8 = {
  class: /*#__PURE__*/_normalizeClass([
                  'badge',
                  'badge-outline',
                  'pertukaran',
                  'mb-2',
                  'me-2',
                ])
}
const _hoisted_9 = {
  class: /*#__PURE__*/_normalizeClass([
                  'badge',
                  'badge-outline',
                  'penempatan',
                  'mb-2',
                  'me-2',
                ])
}
const _hoisted_10 = { class: "ms-auto mb-2" }
const _hoisted_11 = { class: "text-gray-600" }
const _hoisted_12 = { class: "text-gray-600 d-flex" }
const _hoisted_13 = { class: "card-footer p-5" }
const _hoisted_14 = { class: "row" }
const _hoisted_15 = { class: "col-3" }
const _hoisted_16 = { class: "col-9" }
const _hoisted_17 = {
  key: 0,
  class: "text-danger fw-bolder"
}
const _hoisted_18 = {
  key: 1,
  class: "text-danger fw-bolder"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("div", _hoisted_3, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.naikPangkatBorangList, (item, index) => {
        return (_openBlock(), _createElementBlock("div", {
          key: index,
          class: "col-md-4"
        }, [
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("div", _hoisted_5, [
              _createElementVNode("div", _hoisted_6, [
                _createElementVNode("span", _hoisted_7, _toDisplayString(_ctx.getPromotionType(item.kategori_permohonan)), 1),
                _createElementVNode("span", _hoisted_8, _toDisplayString(item.tahun), 1),
                _createElementVNode("span", _hoisted_9, _toDisplayString(item.penempatan_khas == 1 ? "Penempatan Khas" : ""), 1),
                _createElementVNode("div", _hoisted_10, [
                  _createElementVNode("span", {
                    class: _normalizeClass(["badge fw-bolder fs-7", [
                    item.status == 'BARU' || !item.status ? 'badge-info' : '',
                    item.status == 'BUKA' || item.status == 'AKTIF'
                     ? 'badge-primary' : '',
                    item.status == 'MENUNGGU_KEPUTUSAN' ||
                    item.status == 'SEMAKAN' ||
                    item.status == 'SELESAI' ||
                    item.status == 'TIDAK AKTIF'
                      ? 'badge-danger'
                      : '',
                  ]])
                  }, _toDisplayString(_ctx.statusLabel(item.status)), 3)
                ])
              ]),
              _createElementVNode("h4", null, _toDisplayString(item.tajuk), 1),
              _createElementVNode("span", _hoisted_11, " Tarikh Iklan Dibuka Pada " + _toDisplayString(_ctx.formatDate(item.tarikh_permohonan_mula)), 1),
              _createElementVNode("span", _hoisted_12, " Tarikh Tutup Permohonan " + _toDisplayString(_ctx.formatDate(item.tarikh_permohonan_tamat)), 1)
            ]),
            _createElementVNode("div", _hoisted_13, [
              _createElementVNode("div", null, [
                _createElementVNode("div", _hoisted_14, [
                  _createElementVNode("div", _hoisted_15, [
                    (_ctx.isAuthenticated())
                      ? (_openBlock(), _createBlock(_component_router_link, {
                          key: 0,
                          to: `/perkhidmatan/permohonan/${item.id}`,
                          class: "btn btn-sm btn-ispk-active text-white"
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(" Mohon ")
                          ]),
                          _: 2
                        }, 1032, ["to"]))
                      : _createCommentVNode("", true)
                  ]),
                  _createElementVNode("div", _hoisted_16, [
                    (_ctx.permohonanSaya.map((p) => p.naik_pangkat_id).indexOf(item.id) < 0)
                      ? (_openBlock(), _createElementBlock("span", _hoisted_17, "Notis: Hanya pemohon yang terlibat sahaja boleh memohon"))
                      : (_openBlock(), _createElementBlock("span", _hoisted_18, "Permohonan Anda Sedang Diproses."))
                  ])
                ])
              ])
            ])
          ])
        ]))
      }), 128))
    ])
  ]))
}